import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import colors from '@theme/colors';
import { Button, Icon, H2 } from '@atoms';
import { FlexContainer, Whitespace } from '@layout';
import messages from './messages';

const inlineStyles = {
  button: {
    color: colors.DARK_GREY,
    backgroundColor: '#d8d8d8',
    border: '1px solid #d8d8d8',
    fontSize: '18px',
    fontWeight: 700,
  },
  regenerate: {
    color: colors.GREY,
    fontSize: '12px',
    cursor: 'pointer',
    display: 'inline-block',
  },
  pinWrapper: {
    margin: '0 22px',
  },
  buttonWrapper: {
    padding: '8px 0',
  },
};

export const Regenerator = ({ regeneratePin }) => (
  <FlexContainer
    id="pin-regenerate"
    inline
    gap="5px"
    style={inlineStyles.regenerate}
    onClick={regeneratePin}
  >
    <Icon name="refreshGrey" />
    <FormattedMessage {...messages.regenerate} />
  </FlexContainer>
);

export const Pin = ({ pin, regeneratePin, loading }) => (
  <div>
    <Whitespace size="1rem" />
    <H2>
      <FormattedMessage {...messages.title} />
    </H2>
    <div style={pin ? inlineStyles.pinWrapper : {}}>
      <FlexContainer centered gap="22px">
        {pin && (
          <Button
            id="pin-button"
            big
            style={inlineStyles.button}
            onClick={() => navigator.clipboard.writeText(pin)}
            loading={loading}
          >
            <FlexContainer inline gap="10px">
              <span>{pin}</span>
              <Icon name="copyTeal" />
            </FlexContainer>
          </Button>
        )}
        <Regenerator regeneratePin={regeneratePin} />
      </FlexContainer>
    </div>
  </div>
);

Pin.propTypes = {
  pin: PropTypes.string,
  regeneratePin: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

Pin.defaultProps = {
  loading: false,
};

export const SummaryPin = ({ pin, regeneratePin, loading }) => (
  <div>
    <FormattedMessage {...messages.title} />
    <div style={inlineStyles.buttonWrapper}>
      {pin && (
        <Button
          id="pin-button"
          invisible
          onClick={() => navigator.clipboard.writeText(pin)}
          loading={loading}
        >
          {pin}
        </Button>
      )}
    </div>
    <Regenerator regeneratePin={regeneratePin} />
  </div>
);

SummaryPin.propTypes = {
  pin: PropTypes.string,
  regeneratePin: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

SummaryPin.defaultProps = {
  loading: false,
};



// WEBPACK FOOTER //
// ./components/molecules/Pin/Pin.js